import React, {createContext, useContext} from 'react';

const RefreshContext = createContext(undefined);

export const useRefresh = () => {
    const context = useContext(RefreshContext);
    if (context === undefined) {
        throw new Error('useRefresh must be used within a RefreshProvider');
    }
    return context;
};

export const RefreshProvider = ({children, trigger}) => {
    return (
        <RefreshContext.Provider value={{refreshTrigger: trigger}}>
            {children}
        </RefreshContext.Provider>
    );
};
